import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit } from '@angular/core';
import { FindUserConfigService } from '../../../../../shared/services/find-user-config.service';
import { UpdateUserConfigService } from '../../../../../shared/services/update-user-config.service';
import { AssignAdminToBusinessService } from '../../../action/components/crm/profile/services/assignAdminToBusiness.service';
import { GetAssignableAdminsMangementService } from '../../../action/components/mangement/get-assignable-admins.service';
import { Report, SelectionAction } from '../../report';
import { MakeBusinessJunk } from '../../services/make.business.junk.service';
import { SellerService } from './sellers.service';
import Swal from "sweetalert2";
import { DeleteAssignAdminToBusinessService } from '../../../action/components/crm/profile/services/deleteAssignAdminToBusiness.service';
import { SellerActivationStatuses } from '../../../action/components/crm/profile/services/seller-activation-statuses';

@Component({
  selector: 'app-sellers',
  templateUrl: './sellers.component.html',
  styleUrls: ['./sellers.component.scss']
})
export class SellersComponent implements OnInit {
  public searchKey!: string;
  public searchId!: number;
  public currentPage!: number;
  public limit!: number;
  public numPages!: number;
  public tablename: string = 'settlement';
  admins: { key:string, value:string }[] = [];
  defaultColumns: string[] = [
    'id',
    'name',
    'email',
    'first_name',
    'last_name',
    'productsCount',
    'code',
    'amount',
    'salesCount',
    'phone',
    'createdAt',
    'ref',
    "businessType",
    "activationStatus",
    "contractStatus",
    "last_signin_str",
    "adminName"
  ];

  displayTableColumns = {
    'id': 'Business Id',
    'name': 'Business Name',
    'email': 'owner Email',
    'phone': 'owner Phone',
    'first_name': 'owner Name',
    'amount': 'sales Amount',
    'salesCount': 'sales count',
    'productsCount': 'product Count',
    'code': 'referral Code',
    'createdAt': 'register Date',
    'ref': 'Register Path',
    "businessType": 'Business Type',
    "activationStatus": 'Activation Status',
    "contractStatus": 'Contract Status',
    "last_signin_str": 'Last Signin Date',
    "adminName": "Assigned Admin"
  };
  public filterFields = [
    {
      filterFieldName: "BusinessType",
      filterDisplayName: "Business Type",
      defaultValue: null,
      filterOptions: [
        { key: "Show All", value: null },
        { key: "Individual", value: "Individual" },
        { key: "Company", value: "Company" },
        { key: "Junk", value: "Junk" }
      ]
    },
    {
      filterFieldName: "contractStatus",
      filterDisplayName: "Contract Status",
      defaultValue: null,
      filterOptions: [
        { key: "Show All", value: null },
        { key: "empty", value: "empty" },
        { key: "submitted", value: "submitted" },
        { key: "confirmed", value: "confirmed" },
        { key: "shipped", value: "shipped" },
        { key: 'signed', value: 'signed' },
      ]
    }
  ];
  selectionActions: SelectionAction[] = [
    {
      actionName: "Assign Owner",
      actionValue: "AssignOwner",
      actionType: "Button",
      actionClass: "btn-success"
    },
    {
      actionName: "Unassign Owner",
      actionValue: "RemoveAssignedOwner",
      actionType: "Button",
      actionClass: "btn-danger"
    },
    {
      actionName: "Make it Junk",
      actionValue: "Junk",
      actionType: "Button",
      actionClass: "btn-primary"
    },
  ];
  selectionModel = new SelectionModel<any>(true, []);
  selectedColumns: string[] = [];
  displayedColumns: string[] = [];
  dataSource!: any;
  requestBody: Report = {};
  loading = false;
  constructor(
    private findTableConfig: FindUserConfigService,
    private updateUserConfig: UpdateUserConfigService,
    public sellerReport: SellerService,
    private makeBusinessJunk: MakeBusinessJunk,
    private getAssignableAdmins: GetAssignableAdminsMangementService,
    private assignAdminToBusiness: AssignAdminToBusinessService,
    private deleteAssignAdminToBusiness: DeleteAssignAdminToBusinessService,
    private sellerActivationStatuses: SellerActivationStatuses,
  ) { }


  async ngOnInit() {
    this.sellerReport.activateLoader();

    try {
      const sellerStatusResp: {} = await this.sellerActivationStatuses.make();
      const sellerStatus = Object.entries(sellerStatusResp).map((val) => ({
        key: val[0],
        value: val[1],
      }));
      const filterOptions = [
        { key: "Show All", value: null },
      ];
      filterOptions.push(...sellerStatus);
      this.filterFields.push(
        {
          filterFieldName: "activationStatus",
          filterDisplayName: "Activation Status",
          defaultValue: null,
          filterOptions,
        },
      );
      await this.getAdmins()
      this.findTableConfig.setParams({
        tablename: this.tablename
      });
      const r = await this.findTableConfig.make();
      if (r.message === 'Not Found') {
        this.selectedColumns = [...this.defaultColumns];
        this.updateDisplayedColumns();
      } else {
        this.selectedColumns = [...r];
        this.updateDisplayedColumns();
        console.log(
          'selected columns in false after request',
          this.selectedColumns
        );
        console.log(
          'displayed columns in false after request',
          this.displayedColumns
        );
      }
      this.requestBody.paginationOptions = {
        start: 0,
        limit: 10
      };

      this.updateTable();
      this.currentPage = 1;
    } catch (error) {
      console.log(error);
    }
  }
  // ----------------------------------------------------------
  async updateUserConfigSelection() {
    this.updateUserConfig.setParams({
      tablename: this.tablename,
      colums: this.selectedColumns
    });
    await this.updateUserConfig.make();
  }
  updateDisplayedColumns() {
    this.displayedColumns = [...this.selectedColumns];
  }
  openedChange(openned: boolean) {
    if (openned === false) {
      this.displayedColumns = [...this.selectedColumns];
    }
  }


  async filter(event: any) {
    if (event && Object.keys(event).length) {
      this.requestBody.filterOptions = event;
    } else {
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.sellerReport.loader().subscribe(val => (this.loading = val));
  }

  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize
    };
    this.updateTable();
    this.sellerReport.loader().subscribe(val => (this.loading = val));
  }

  async searchChange(event: any) {
    if (event) {
      this.requestBody.searchOptions = {
        searchKey: event
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.sellerReport.loader().subscribe(val => (this.loading = val));
    }
    await this.updateTable();
  }

  async sortChange(event: any) {
    if (event.direction === '') {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.sellerReport.loader().subscribe(val => (this.loading = val));
  }

  async updateTable() {
    this.sellerReport.activateLoader();
    this.sellerReport.setParams(this.requestBody);
    const response = await this.sellerReport.make();
    this.dataSource = (response['result']);
    this.numPages = response.totalNumberOfRows;
  }

  async selectionActionsCB(event: any) {
    try {
        switch (event.action) {
          case 'AssignOwner':
            const { value: adminId }:any = await Swal.fire({
              input: 'select',
              inputOptions: this.admins.map((admin)=> admin.key),
              inputPlaceholder: 'Assign Owner',
              showCancelButton: true,
            });
            const assignedAdminId = this.admins[adminId].value;
            this.assignAdminToBusiness.setParams({
                businessId: event.selection.map((i: any) => i.id),
                adminId: assignedAdminId
             });
            await this.assignAdminToBusiness.make();
            this.selectionModel.clear();
            this.updateTable();
            this.sellerReport.loader().subscribe(val => (this.loading = val));
            break;
          case 'RemoveAssignedOwner':
            this.deleteAssignAdminToBusiness.setParams({
              businessId: event.selection.map((i: any) => i.id),
            })
            await this.deleteAssignAdminToBusiness.make();
            this.selectionModel.clear();
            this.updateTable();
            this.sellerReport.loader().subscribe(val => (this.loading = val));
            break;
          case 'Junk':
              this.makeBusinessJunk.setParams({
                idList: event.selection.map((i: any) => i.id),
                businessType: event.action
              });
              await this.makeBusinessJunk.make();
              this.selectionModel.clear();
              this.updateTable();
              this.sellerReport.loader().subscribe(val => (this.loading = val));
            break;
        }

    } catch (err) {
      console.log(err);
    }
  }

  async getAdmins() {
    const allAdmins = await this.getAssignableAdmins.make();
    let parsedAdmins = [{ key: 'Show All', value: null }];
    for (const admin of allAdmins) {
        parsedAdmins.push({
          key: admin.first_name + ' ' + admin.last_name,
          value: String(admin.id),
        });

        this.admins.push({
          key: admin.first_name + ' ' + admin.last_name,
          value: String(admin.id),
        });;
    }
    this.filterFields.push({
      filterFieldName: 'adminId',
      filterDisplayName: 'Assigned Admin',
      defaultValue: null,
      filterOptions: parsedAdmins,
    });
  }

}
